import React from 'react';
import numeral from "numeral";
import './InfoBox.css';
import{
       Card,
    CardContent,
    Typography
  }  from '@material-ui/core';

function InfoBox({title, cases, isRed,active, totals, ...props}) {
    return (
        <Card onClick={props.onClick} className={`info-box ${active && 'info-box--selected'} ${isRed && 'info-box--red'}`}>
           <CardContent>
               {/* title */}
                <Typography className="info-box__title" color="textSecondary">
                    {title}
                </Typography>
               {/* Number of new Cases */}
               <h2 className={`info-box__cases ${!isRed && 'infoBox__cases--green'}`} > {totals}</h2>
               {/* total Cases */}
               <Typography className="info-box__totals" color="textSecondary">
               {cases} Total
               </Typography>
           </CardContent> 
        </Card>
    )
}

export default InfoBox
//Cases : {numeral(country.cases).format("0,0")}